export type ProductCategory = {
  name: string;
  slug: string;
  desc?: string;
  subcategories: { name: string; slug: string }[];
};

export const PRODUCT_CATEGORIES: ProductCategory[] = [
  {
    name: "Womens Health",
    slug: "womens-health",
    desc: "Hormonal balance, PCOS support, wellness.",
    subcategories: [
      { name: " Multivitamin for Women", slug: "multivitamin-women" },
      { name: "Iron & Folic Acid", slug: "iron-folic-acid" },
      { name: "Evening Primrose Oil", slug: "evening-primrose-oil" },
      { name: "Shatavari Capsules", slug: "shatavari-capsules" },
      {
        name: " D-Mannose & Cranberry Extract",
        slug: "d-mannose-cranberry-extract",
      },
      {
        name: "Collagen with Hyaluronic Acid",
        slug: "collagen-hyaluronic-acid",
      },
      { name: "Magnesium & B6", slug: "magnesium-b6" },
      { name: "DIM (Diindolylmethane)", slug: "dim-diindolylmethane" },
      { name: "Omega-3 DHA & EPA", slug: "omega-3-dha-epa" },
      { name: "Probiotic Blend for Women", slug: "probiotic-blend-women" },
    ],
  },
  {
    name: "Energy & Vitality",
    slug: "energy-vitality",
    desc: "Daily energy, stamina & recovery.",
    subcategories: [
      { name: "Shilajit", slug: "shilajit" },
      { name: "Creatine Gummies", slug: "creatine-gummies" },
      { name: "CoQ10 Capsules", slug: "coq10-capsules" },
      { name: "B-Complex Vitamins", slug: "b-complex-vitamins" },
      { name: "Maca Root & Ginseng", slug: "maca-root-ginseng" },
      { name: "Cordyceps Mushroom Extract", slug: "cordyceps-mushroom-extract" },
      { name: "Iron & Vitamin C", slug: "iron-vitamin-c" },
      { name: "Caffeine & L-Theanine", slug: "caffeine-l-theanine" },
      { name: "Rhodiola Rosea Extract", slug: "rhodiola-rosea-extract" },
      { name: "D-Ribose Powder", slug: "d-ribose-powder" },
      { name: "MCT Oil Capsules", slug: "mct-oil-capsules" },
      { name: "Beetroot Extract", slug: "beetroot-extract" }
    ],
  },
  {
    name: "Weight Management",
    slug: "weight-management",
    desc: "Metabolism & appetite support.",
    subcategories: [
      { name: "Garcinia Cambogia", slug: "garcinia-cambogia" },
      { name: "Green Tea Extract", slug: "green-tea-extract" },
      {
        name: "CLA (Conjugated Linoleic Acid)",
        slug: "cla-conjugated-linoleic-acid",
      },
      {
        name: "Apple Cider Vinegar Capsules",
        slug: "apple-cider-vinegar-capsules",
      },
      { name: "L-Carnitine Capsules", slug: "l-carnitine-capsules" },
      { name: "Glucomannan Fiber", slug: "glucomannan-fiber" },
      { name: "Forskolin Extract", slug: "forskolin-extract" },
      { name: "Chromium Picolinate", slug: "chromium-picolinate" },
      { name: "Keto Electrolyte Blend", slug: "keto-electrolyte-blend" },
      { name: "Capsaicin Extract", slug: "capsaicin-extract" },
    ],
  },
  {
    name: "Skin, Hair & Nail Health",
    slug: "skin-hair-nails",
    desc: "Glow, strength and nourishment.",
    subcategories: [
       { name: "Collagen Peptides", slug: "collagen-peptides" },
      { name: "Biotin & Keratin", slug: "biotin-keratin" },
      { name: "Hyaluronic Acid", slug: "hyaluronic-acid" },
      { name: "Silica & Bamboo Extract", slug: "silica-bamboo-extract" },
      { name: "Vitamin E", slug: "vitamin-e" },
      { name: "Omega-3 & Evening Primrose Oil", slug: "omega-3-evening-primrose-oil" },
      { name: "Astaxanthin Capsules", slug: "astaxanthin-capsules" },
      { name: "Zinc & Selenium", slug: "zinc-selenium" },
      { name: "Glutathione Capsules", slug: "glutathione-capsules" },
      { name: "MSM Capsules", slug: "msm-capsules" },
    ],
  },
  {
    name: "Cardiovascular Health",
    slug: "cardiovascular-health",
    desc: "Heart health & circulation.",
    subcategories: [
      { name: "Coenzyme Q10", slug: "coenzyme-q10" },
      { name: "Omega-3 Fish Oil", slug: "omega-3-fish-oil" },
      { name: "Hawthorn Berry Extract", slug: "hawthorn-berry-extract" },
      { name: "Magnesium & Potassium", slug: "magnesium-potassium" },
      { name: "Garlic Extract", slug: "garlic-extract" },
      { name: "L-Arginine", slug: "l-arginine" },
      { name: "Berberine Capsules", slug: "berberine-capsules" },
      { name: "Resveratrol with Grape Seed", slug: "resveratrol-grape-seed" },
      { name: "Plant Sterols", slug: "plant-sterols" },
      { name: "Folic Acid & B-Vitamins", slug: "folic-acid-b-vitamins" },
    ],
  },
  {
    name: "Cognitive & Brain Health",
    slug: "brain-health",
    desc: "Focus, clarity & mood.",
    subcategories: [
     { name: "Nootropic Blends", slug: "nootropic-blends" },
      { name: "Omega-3 DHA & EPA", slug: "omega-3-dha-epa" },
      { name: "Phosphatidylserine Capsules", slug: "phosphatidylserine-capsules" },
      { name: "L-Theanine & Caffeine", slug: "l-theanine-caffeine" },
      { name: "Lion Mane Mushroom Extract", slug: "lion-mane-mushroom-extract" },
      { name: "Acetyl-L-Carnitine", slug: "acetyl-l-carnitine" },
      { name: "Citicoline (CDP-Choline)", slug: "citicoline-cdp-choline" },
      { name: "Vitamin B Complex", slug: "vitamin-b-complex" },
      { name: "Magnesium L-Threonate", slug: "magnesium-l-threonate" },
      { name: "Curcumin with Piperine", slug: "curcumin-piperine" },
    ],
  },
  {
    name: "Joint & Mobility",
    slug: "joint-mobility",
    desc: "Flexibility & movement support.",
    subcategories: [
     { name: "Glucosamine & Chondroitin", slug: "glucosamine-chondroitin" },
      { name: "Turmeric Curcumin", slug: "turmeric-curcumin" },
      { name: "Collagen Type II", slug: "collagen-type-ii" },
      { name: "Hyaluronic Acid", slug: "hyaluronic-acid" },
      { name: "MSM Capsules", slug: "msm-capsules" },
      { name: "Boswellia Serrata", slug: "boswellia-serrata" },
      { name: "Ginger Extract", slug: "ginger-extract" },
      { name: "Omega-3 Fatty Acids", slug: "omega-3-fatty-acids" },
      { name: "Vitamin D3 & K2", slug: "vitamin-d3-k2" },
      { name: "Boron Supplement", slug: "boron-supplement" },
    ],
  },
  {
    name: "Eye Health",
    slug: "eye-health",
    desc: "Vision and screen support.",
    subcategories: [
     { name: "Lutein & Zeaxanthin", slug: "lutein-zeaxanthin" },
      { name: "Bilberry Extract", slug: "bilberry-extract" },
      { name: "Omega-3 DHA", slug: "omega-3-dha" },
      { name: "Vitamin A & Beta-Carotene", slug: "vitamin-a-beta-carotene" },
      { name: "Astaxanthin", slug: "astaxanthin" },
      { name: "Ginkgo Biloba", slug: "ginkgo-biloba" },
      { name: "Zinc & Copper", slug: "zinc-copper" },
      { name: "Eyebright Herb Extract", slug: "eyebright-herb-extract" },
      { name: "N-Acetyl Cysteine (NAC)", slug: "n-acetyl-cysteine-nac" },
      { name: "Saffron Extract", slug: "saffron-extract" },
    ],
  },
  {
    name: "Aging & Longevity",
    slug: "aging-longevity",
    desc: "Cellular wellness & vitality.",
    subcategories: [
       { name: "Resveratrol & Quercetin", slug: "resveratrol-quercetin" },
      { name: "NAD+ Boosters (NMN or NR)", slug: "nad-boosters-nmn-nr" },
      { name: "Collagen Peptides", slug: "collagen-peptides" },
      { name: "CoQ10", slug: "coq10" },
      { name: "Curcumin & Piperine", slug: "curcumin-piperine" },
      { name: "Glutathione Capsules", slug: "glutathione-capsules" },
      { name: "DHEA Supplements", slug: "dhea-supplements" },
      { name: "Vitamin C & E", slug: "vitamin-c-e" },
      { name: "Pterostilbene Capsules", slug: "pterostilbene-capsules" },
      { name: "Omega-3 DHA & EPA", slug: "omega-3-dha-epa" },
    ],
  },
  {
    name: "Sleep Support",
    slug: "sleep-support",
    desc: "Relaxation and deep sleep.",
    subcategories: [
    { name: "Melatonin Capsules", slug: "melatonin-capsules" },
      { name: "Magnesium Glycinate", slug: "magnesium-glycinate" },
      { name: "L-Theanine Capsules", slug: "l-theanine-capsules" },
      { name: "GABA & 5-HTP", slug: "gaba-5-htp" },
      { name: "Chamomile & Valerian Root", slug: "chamomile-valerian-root" },
      { name: "Ashwagandha with L-Tryptophan", slug: "ashwagandha-l-tryptophan" },
      { name: "Passionflower Extract", slug: "passionflower-extract" },
      { name: "CBD & Hemp Extract", slug: "cbd-hemp-extract" },
      { name: "Reishi Mushroom Capsules", slug: "reishi-mushroom-capsules" },
      { name: "Glycine & Taurine", slug: "glycine-taurine" },
    ],
  },
  {
    name: "Sexual Wellness",
    slug: "sexual-wellness",
    desc: "Performance & confidence.",
    subcategories: [
     { name: "Shilajit", slug: "shilajit" },
      { name: "Maca Root Extract", slug: "maca-root-extract" },
      { name: "Tongkat Ali & Tribulus Terrestris", slug: "tongkat-ali-tribulus-terrestris" },
      { name: "Ashwagandha with Black Pepper", slug: "ashwagandha-black-pepper" },
      { name: "L-Arginine & L-Citrulline", slug: "l-arginine-l-citrulline" },
      { name: "Fenugreek Extract", slug: "fenugreek-extract" },
      { name: "Horny Goat Weed & Ginseng", slug: "horny-goat-weed-ginseng" },
      { name: "Zinc & Magnesium", slug: "zinc-magnesium" },
      { name: "Shatavari Capsules", slug: "shatavari-capsules" },
      { name: "DHEA Supplements", slug: "dhea-supplements" },
      { name: "Saffron Extract", slug: "saffron-extract" },
    ],
  },
  {
    name: "Immune Support",
    slug: "immune-support",
    desc: "Daily immune defense.",
    subcategories: [
      { name: "Vitamin C with Zinc & D3", slug: "vitamin-c-zinc-d3" },
      { name: "Elderberry & Echinacea", slug: "elderberry-echinacea" },
      { name: "Probiotic & Prebiotic Blend", slug: "probiotic-prebiotic-blend" },
      { name: "Quercetin with Bromelain", slug: "quercetin-bromelain" },
      { name: "Astragalus Root Extract", slug: "astragalus-root-extract" },
      { name: "Colostrum Capsules", slug: "colostrum-capsules" },
      { name: "Beta-Glucans & Mushroom Complex", slug: "beta-glucans-mushroom-complex" },
      { name: "Glutathione Capsules", slug: "glutathione-capsules" },
      { name: "Olive Leaf Extract", slug: "olive-leaf-extract" },
      { name: "NAC (N-Acetyl Cysteine)", slug: "nac-n-acetyl-cysteine" },
      { name: "Shilajit", slug: "shilajit" },
    ],
  },
  {
    name: "Gut Health",
    slug: "gut-health",
    desc: "Digestion & microbiome support.",
    subcategories: [
      { name: "Probiotic & Prebiotic Blend", slug: "probiotic-prebiotic-blend" },
      { name: "Digestive Enzyme Complex", slug: "digestive-enzyme-complex" },
      { name: "L-Glutamine Capsules", slug: "l-glutamine-capsules" },
      { name: "Psyllium Husk Fiber Capsules", slug: "psyllium-husk-fiber-capsules" },
      { name: "Apple Cider Vinegar Capsules", slug: "apple-cider-vinegar-capsules" },
      { name: "Aloe Vera Extract", slug: "aloe-vera-extract" },
      { name: "Slippery Elm & Marshmallow Root", slug: "slippery-elm-marshmallow-root" },
      { name: "Saccharomyces Boulardii Probiotic", slug: "saccharomyces-boulardii-probiotic" },
      { name: "Fennel Seed & Ginger Extract", slug: "fennel-seed-ginger-extract" },
      { name: "Berberine Capsules", slug: "berberine-capsules" },
    ],
  },
];
